import React, { useState } from 'react';
import { Form } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import {useFormContext} from 'clayco-controls';

const CertificationUploadField = ({ name, handleUpload }) => {

    const {t} = useTranslation();
    const { formState, register } = useFormContext();
    const [fileData, setFileData] = useState();
    const [errMessage, setErrMessage] = useState(t('Required'));

    let errObj = {};

    // Get nested error states
    const compoundName = name.indexOf(".") != -1 ? name.split(".") : "";
    if (compoundName.length > 0) {
      errObj = formState.errors;
      for (var i = 0; i < compoundName.length; i++) {
        if (errObj[compoundName[i]] == (null || undefined)){
          errObj = null;
          break;
        }
        errObj = errObj[compoundName[i]];
      }
    }
  
    const onFileChange = (e) => {

      if (e.target.files.length === 0) {
        setErrMessage(t('Required'))
      }
      else {
        setErrMessage(errObj?.message)
      }
      handleUpload(e);
    }

    return(
        <>
        <div className="px-2 py-1">
          <Form.Group>
              <div className="input-group">
              <Form.Control 
                  {...register(name)} 
                  className='form-control' 
                  type={'file'} 
                  value={fileData}
                  isInvalid={!!errObj} 
                  accept={'.jpg, .png, .jpeg, .gif, .heic, .pdf'} 
                  onChange={onFileChange} 
                />
              </div>
              <Form.Control.Feedback type="invalid" style={{display: "block", "textAlign": "left"}}>
                {errMessage}
              </Form.Control.Feedback>
          </Form.Group>
        </div>
        </>
    );
}

export default CertificationUploadField;